import ABCyaPhaser from "@abcya/abcya_phaser";
import gameData from "../gameData";

export default class Btn extends Phaser.GameObjects.Container
{
    constructor(scene, i, l, s)
    {
        super(scene);
        scene.add.existing(this);

        this.scene = scene;
        this.ind = i;
        this.isLocked = l;
        this.score = s;
        this.isSelected = false;
        this.adj = i + 1;
		
        this.createItem();

        this.on("pointerup", ()=>{ this.clickHandler(); });
    }

	createItem() {
        for(var b = 0; b < 9; b++){
            if(this.ind == b){
                if(b == 0){
                    this.body = ABCyaPhaser.Images.addImage(0, 0, "blankOpen", this);
                    this.numTxt = ABCyaPhaser.Text.addText(0, 0, 45, "0xFFFFFF", gameData.GAME_FONTS[1], "Arcade\nMode", this).setStroke("#BA6222", 5);
                    this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, 20, "0xBA6222", gameData.GAME_FONTS[1], String(this.score), this);

                    this.scoreTxt.x = 20;
                    this.scoreTxt.y = this.body.getBounds().height/3 - 8;
                    this.numTxt.y = -this.body.getBounds().height/3 + 35;
                } else {
                    if(this.isLocked){
                        this.body = ABCyaPhaser.Images.addImage(0, 0, "blankLocked", this);
                        this.levelTxt = ABCyaPhaser.Text.addText(0, 0, 20, "0x466C75", gameData.GAME_FONTS[1], "level " + this.ind, this);
                    } else {
                        this.body = ABCyaPhaser.Images.addImage(0, 0, "blankOpen", this);
                        this.levelTxt = ABCyaPhaser.Text.addText(0, 0, 20, "0xBA6222", gameData.GAME_FONTS[1], "level " + this.ind, this);
                        this.numTxt = ABCyaPhaser.Text.addText(0, 0, 60, "0xFFFFFF", gameData.GAME_FONTS[1], String(this.ind) + "-" + String(this.ind + 4), this).setStroke("#BA6222", 5);
                        this.scoreTxt = ABCyaPhaser.Text.addText(0, 0, 25, "0xBA6222", gameData.GAME_FONTS[1], String(this.score), this);

                        this.scoreTxt.x = 20;
                        this.scoreTxt.y = this.body.getBounds().height/3 - 8;
                        this.numTxt.y = -8;
                    }

                    this.levelTxt.y = -this.body.getBounds().height/3 - 8;
                }
            }
        };

        this.setSize(this.body.getBounds().width, this.body.getBounds().height);
        if(!this.isLocked) this.setInteractive({ cursor: 'pointer' });
	};

    clickHandler() {
        console.log("clicked " + this.ind);
        ABCyaPhaser.Audio.playOneShot("Click", this.scene);
        gameData.GAME_LEVEL = this.ind;

        if(this.ind == 0){
            gameData.GAME_MODE = "arcade";
            gameData.INTRO_STEP = 0;
        } else {
            gameData.GAME_MODE = "level";
        }

        this.disableInteractive();

        this.scene.destroyIntro();
    };
}